import classNames from "classnames";
import { OptionType } from "../../SelectInput";
import { MultiSelectProps } from "../MultiSelect";
import { MultiSelectElement } from "./MultiSelectElement";

export type MultiSelectOptionsProps = {
  options: OptionType[];
  selectedOptions: MultiSelectProps["selectedOptions"];
  onSelectOption?: (value: string) => void;
};

export const MultiSelectOptions = (props: MultiSelectOptionsProps) => {
  const { options, selectedOptions, onSelectOption } = props;
  const multiSelectOptionsClass = {
    optionsWrapper:
      "absolute top-0 z-10 bg-white border border-slate-300 rounded w-full max-h-60 overflow-y-auto top left-1/2 transform -translate-x-1/2",
  };

  return (
    <div
      className={classNames(multiSelectOptionsClass.optionsWrapper)}
      role="listbox"
    >
      {options.map((option) => {
        const isSelected = selectedOptions?.includes(option.value.toString());

        return (
          <MultiSelectElement
            key={"multi-select-option-key-" + option.value}
            option={option}
            isSelected={isSelected}
            onSelectOption={onSelectOption}
          />
        );
      })}
    </div>
  );
};
